import { useNavigate } from 'react-router-dom';

import type {
  GetDashboardListingsQuery,
  GetDashboardListingsQueryVariables,
} from '@graphql/__generated__/graphql';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { DashboardListingsCardItem } from '@modules/dashboard/dashboard-listings/DashboardListingsCardItem';
import { GET_DASHBOARD_LISTINGS } from '@modules/dashboard/dashboardQueries';
import { useDashboardList } from '@modules/dashboard/hooks/useDashboardList';
import { DashboardCard } from '@modules/dashboard/shared/DashboardCard';
import { useLocale } from '@shared/hooks/locale';

export const DashboardListingsCard = () => {
  const { t } = useLocale();
  const { me } = useAppData();
  const navigate = useNavigate();

  const userIds = [...(me?.user_ids_in_led_teams ?? []), me?.id].filter(
    (id): id is string => !!id,
  );

  const queryResult = useDashboardList<
    GetDashboardListingsQuery,
    GetDashboardListingsQueryVariables,
    GetDashboardListingsQuery['lots'][number]
  >({
    query: GET_DASHBOARD_LISTINGS,
    variables: {
      userIds,
    },
    dataKey: 'lots',
    countKey: 'lots_aggregate',
    fetchPolicy: 'network-only',
  });

  const handleCreateListing = () => {
    navigate('/listings/new/scratch/');
  };

  return (
    <DashboardCard
      title={t('Listings')}
      actionLabel={t('View all listings')}
      actionLink="/listings"
      queryResult={queryResult}
      renderItem={(listing, key) => (
        <DashboardListingsCardItem key={key} listing={listing} />
      )}
      emptyStateMessage={t('You have not created any listings yet,')}
      emptyStateActionLabel={t('create your first one')}
      onEmptyStateAction={handleCreateListing}
      hideBadge
    />
  );
};
